import React from "react";
import classes from "./NavBar.module.css";
import { Link } from "react-router-dom";
import logo from './mydrugs.png'
import '../fontawesome/css/all.css'
import { useContext } from "react";
import CartContext from "../store/CartContext";


const NavBar = (props) => {
  
  const cartContext = useContext(CartContext);
  
  const numCartItems =cartContext.items.reduce((curNumber, item)=>{
    return curNumber+ item.amount;
  },0)



  return (
    <div className={classes.nav}>
      <ul>
        <div className={classes.navleft}>
          <li>
            <Link to="/Shop">
              SHOP
            </Link>
          </li>
          <li>
            <Link to="/FAQ">
              FAQ
            </Link>
          </li>
        </div>
        <div className={classes.logo}>
          <li>
            <Link to="/">
              <img  alt='logo' src={logo}></img>
            </Link>
          </li>
        </div>
        <div className={classes.navright}>
          <li>
            <Link to="/Safety">
              SAFETY
            </Link>
          </li>
          <li>
            <Link to="/Contact">
              CONTACT
            </Link>
          </li>
        </div>
      </ul>
      <div className={classes.cart} onClick={props.onToggleCart}>
        <i className="fas fa-shopping-cart"></i> {numCartItems}
    </div>
    </div>
  );
};

export default NavBar;
